import { useSessionContext } from 'features/auth';
import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from './constants';

export const AuthenticatedRoute = ({
  children,
}: {
  children: ReactElement;
}) => {
  const { isLoggedIn } = useSessionContext();
  const status = 'success' ; //useUserContext();
  const location = useLocation();
  if (!isLoggedIn) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }

   if (status === 'success') {
    return children;
  }

  return null;
};
